interface RatingDisplayProps {
  value: number
  showValue?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export function RatingDisplay({ value, showValue = true, size = 'md' }: RatingDisplayProps) {
  const sizeMap = {
    sm: 14,
    md: 16,
    lg: 20,
  }

  const starSize = sizeMap[size]
  const stars = [1, 2, 3, 4, 5]

  return (
    <div className="rating" style={{ gap: '0.125rem' }}>
      {stars.map((star) => (
        <svg
          key={star}
          width={starSize}
          height={starSize}
          viewBox="0 0 24 24"
          fill={star <= Math.round(value) ? 'var(--amz-star)' : 'var(--border)'}
        >
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
      {showValue && (
        <span style={{ marginLeft: '0.5rem', fontSize: starSize - 2, color: 'var(--text-secondary)' }}>
          {value.toFixed(1)}
        </span>
      )}
    </div>
  )
}

interface RatingInputProps {
  value: number
  onChange: (value: number) => void
  size?: 'sm' | 'md' | 'lg'
}

export function RatingInput({ value, onChange, size = 'md' }: RatingInputProps) {
  const sizeMap = {
    sm: 20,
    md: 28,
    lg: 36,
  }

  const starSize = sizeMap[size]
  const stars = [1, 2, 3, 4, 5]

  return (
    <div className="rating" style={{ gap: '0.25rem' }}>
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange(star)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
        >
          <svg
            width={starSize}
            height={starSize}
            viewBox="0 0 24 24"
            fill={star <= value ? 'var(--amz-star)' : 'var(--border)'}
            style={{ transition: 'fill 0.15s ease' }}
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        </button>
      ))}
    </div>
  )
}
